import React from 'react';

import titleMobile from '../img/title-mobile.png';
import btnSocialEmail from '../img/btn-social-email.png';
import btnSocialInstagram from '../img/btn-social-instagram.png';
import btnSocialFacebook from '../img/btn-social-facebook.png';
import btnSocialTwitter from '../img/btn-social-twitter.png';

import coming from './coming.jpg';
import comingOut from './comingout.jpg';
import looking from './looking.jpg';
import sorting from './sorting.jpg';
import thinking from './thinking.jpg';

import './ComingSoon.scss';
import LoginButton from '../components/LoginButton';

const MESSAGES = [
  { src: coming, caption: 'A new website is coming' },
  { src: comingOut, caption: 'New website coming out soon' },
  { src: looking, caption: 'Looking forward to the new website' },
  { src: sorting, caption: "I'm sorting things out on the website" },
  { src: thinking, caption: "I'm thinking about a new website" },
];

function getRandomIndex(): number {
  return Math.floor(Math.random() * MESSAGES.length);
}

type ComingSoonState = {
  messageIndex: number;
};

export class ComingSoon extends React.Component<{}, ComingSoonState> {
  state = { messageIndex: getRandomIndex() };

  showRandomMessage() {
    this.setState({
      messageIndex: getRandomIndex(),
    });
  }

  render() {
    return (
      <div id="coming-soon">
        <div>
          <h1>
            <img src={titleMobile} alt="Who Is NemO'S?" />
          </h1>
          <div
            key={MESSAGES[this.state.messageIndex].src}
            className="message"
            onClick={() => this.showRandomMessage()}
          >
            <img src={MESSAGES[this.state.messageIndex].src} alt="illustration by NemO'S" />
            {MESSAGES[this.state.messageIndex].caption}
          </div>
        </div>
        <nav className="social">
          <a href="https://www.instagram.com/whoisnemos/" target="_blank" rel="noopener noreferrer">
            <img src={btnSocialInstagram} alt="Instagram" />
          </a>
          <a href="https://twitter.com/whoisnemos" target="_blank" rel="noopener noreferrer">
            <img src={btnSocialTwitter} alt="Twitter" />
          </a>
          <a href="https://www.facebook.com/whoisnemos/" target="_blank" rel="noopener noreferrer">
            <img src={btnSocialFacebook} alt="Facebook" />
          </a>
          <br />
          <a href="mailto:info@whoisnemos.com" target="_blank" rel="noopener noreferrer">
            <img src={btnSocialEmail} alt="Email" />
          </a>
          <br />
          <LoginButton className="login" />
        </nav>
      </div>
    );
  }
}
